import { reportTemplate } from '../../util.js';

export const execute = (node, context) => {

  if (node.type === 'text') {
    return reportTemplate(node, [ 'text' ], 'Text', context);
  }

  return true;
};
